import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Globals } from '../global-variables/globals';

@Component({
    selector: 'app-loading',
    templateUrl: './loading-elem.component.html',
    styleUrls: ['./loading-elem.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingElemComponent implements OnInit {

  constructor(public globals: Globals) { }

  ngOnInit() {
  }
}
